import React, { Component } from 'react';

import ConsoleHeader from '../components/StakingConsole/ConsoleHeader';
import Staking from '../components/Staking/StakingOne';
import '../components/StakingConsole/console.css';


class StakingOne extends Component {
    
    
    render() {
        return (
            <div className="staking-console-app">
                <ConsoleHeader />
                <Staking />
            </div>
        );
    }
}

export default StakingOne;
